import { render, staticRenderFns } from "./Endsession.vue?vue&type=template&id=71061d9b"
import script from "./Endsession.vue?vue&type=script&lang=js"
export * from "./Endsession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports